import produce from 'immer';
import { AnyAction } from 'redux';
import * as selectedBlocksActionTypes from '../../constants/actionTypes/selectedBlocks';
import * as canvasBlocksActionTypes from '../../constants/actionTypes/canvasBlocks';
import checkForRemoteUser from '../common/checkForRemoteUser';

const initialState: string[] = [];

const selectedBlocks = (state = initialState, action: AnyAction) =>
    produce(state, (draftState) => {
        switch (action.type) {
            case canvasBlocksActionTypes.ADD_BLOCK: {
                const { indices, remote, currentUserSocketId } = action.payload;
                return checkForRemoteUser(remote, currentUserSocketId) ? draftState : [indices.block[0]];
            }

            case selectedBlocksActionTypes.ADD_SELECTED_BLOCK: {
                const blockID = action.payload.index;
                if (!draftState.includes(blockID)) {
                    draftState.push(blockID);
                }
                break;
            }

            case canvasBlocksActionTypes.REMOVE_BLOCK:
            case selectedBlocksActionTypes.REMOVE_SELECTED_BLOCK: {
                const blockID = action.payload.index;
                if (draftState.includes(blockID)) {
                    return draftState.filter((id) => id !== blockID);
                }
                break;
            }

            case canvasBlocksActionTypes.DUPLICATE_BLOCKS: {
                const { blocks, indices, remote, currentUserSocketId } = action.payload;

                if (checkForRemoteUser(remote, currentUserSocketId)) {
                    return draftState;
                }

                if (blocks.length > 1) {
                    // indices.block contains the same amount of block IDs as duplicated blocks, so we can just set it as the selection
                    return indices.block;
                }

                return [indices.block[0]];
            }

            case selectedBlocksActionTypes.SELECT_ALL_BLOCKS: {
                const { blockIDs } = action.payload;
                blockIDs.forEach((blockID: string) => {
                    if (!draftState.includes(blockID)) {
                        draftState.push(blockID);
                    }
                });
                break;
            }

            case selectedBlocksActionTypes.REMOVE_ALL_SELECTED_BLOCKS:
                return initialState;

            default:
        }
    });

export default selectedBlocks;
